import React, { useState } from 'react';
import apiClient from '@/utils/api';
import { toast } from 'sonner';
import { BookModal } from './WorkflowDialogs';

// The call is already saved. Retrying a failed booking never logs the call twice.
export const CallBookingDialog = ({ booking, onClose, onBooked }) => {
  const [busy, setBusy] = useState(false);
  const book = async body => {
    if (busy) return;
    setBusy(true);
    try {
      const { data } = await apiClient.post(`/workflow/leads/${booking.leadId}/appointments`, body);
      toast.success(`Counselling booked with ${data.appointment.counsellor_name}`);
      onClose();
      window.dispatchEvent(new Event('tasks-changed'));
      onBooked?.(data);
    } catch (e) {
      const detail = e.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'Booking failed. Your call is saved; choose a slot and retry.');
    } finally { setBusy(false); }
  };
  return <BookModal busy={busy} initialNote={booking.notes} onSubmit={book} onClose={() => {
    if (busy) return;
    onClose();
    toast.info('Call saved. Counselling booking remains pending in Tasks.');
  }} />;
};